<template>
  <div class="cancel-order-block text-center text-lg-left" data-testid="cancel-order-block">
    <label class="d-block font-weight-bold text-uppercase pb-2">
      {{ $t('footer.label.cancelOrder') }}
    </label>
    <SBtn
      variant="outlined"
      color="primary"
      height="44"
      class="font14"
      :style="{ borderRadius: '6px', textTransform: 'none' }"
      data-testid="cancel-order-trigger"
      @click="isOpen = true"
    >
      {{ $t('footer.btn.cancelOrder') }}
    </SBtn>
    <CancelOrderPopup v-model="isOpen" />
  </div>
</template>

<script lang="ts" setup>
import CancelOrderPopup from '~/components/layout/footer/CancelOrderPopup.vue'

const isOpen = ref(false)
</script>
